<template>
    <b-modal size="xl"
             centered
             hide-footer
             content-class="rounded-xl border-0 shadow-lg"
             v-bind:visible="value"
             v-on:hide="hideModal"
             v-on:cancel="hideModal">
        <template v-slot:modal-title>
            <strong v-if="!isEditing">
                新增/邀請用戶
            </strong>
            <strong v-else>
                正在編輯用戶《{{ user.name }}》
            </strong>
        </template>

        <b-form v-on:submit.prevent="submit">
            <div class="form-row">
                <div class="col-lg-4 d-flex flex-column">
                    <b-form-group label="用戶頭像 (可選填)"
                                  label-for="avatar">
                        <div class="position-relative avatar-image img-thumbnail"
                             v-on:click="changeAvatar">
                            <input id="avatar"
                                   class="d-none"
                                   type="file"
                                   v-on:change="updateAvatar">
                            <img alt="用戶頭像"
                                 class="w-100 h-100"
                                 v-if="Array.isArray(avatar) && avatar.length > 0"
                                 v-bind:src="avatar[0]">
                            <div class="d-flex justify-content-center align-items-center w-100 h-100"
                                 v-else>
                                <h5 class="text-center font-weight-bold mb-0">
                                    點擊更新👆👆
                                </h5>
                            </div>
                        </div>
                    </b-form-group>

                    <ul class="nav flex-column mb-3">
                        <!-- <li class="nav-item">
                            <a class="nav-link" href="#">要求用戶重設密碼</a>
                        </li> -->
                        <li class="nav-item">
                            <a class="nav-link text-danger" href="#">
                                刪除用戶
                            </a>
                        </li>
                    </ul>
                </div>
                <div class="col-lg-8">
                    <div class="form-row">
                        <b-form-group class="col-md-8"
                                      label-for="allowLogin">
                            <template v-slot:label>
                                <font-awesome-icon v-bind:icon="['fad', 'sign-in']"></font-awesome-icon> 用戶登入設定
                            </template>
                            <template v-slot:description>
                                啟用用戶登入後，用戶將能使用設定的電郵地址和登入密碼登入本系統。<br>
                                故此請確保該用戶的電郵地址 <strong>{{ email }}</strong> 和<strong>登入密碼</strong>正確無誤。<br>
                                如使用密碼產生功能，請把產生的密碼複製至其他地方。產生的密碼在新增/編輯後將無法再次存取。
                            </template>
                            <b-form-checkbox id="allowLogin"
                                             switch
                                             size="lg"
                                             v-model="allowLogin">
                                <small>
                                    <span v-if="allowLogin">用戶登入已被啟用</span>
                                    <span v-else>用戶登入已被停用</span>
                                </small>
                            </b-form-checkbox>
                        </b-form-group>
                        <div class="col-md-12 mb-3">
                            <b-collapse v-model="allowLogin">
                                <div class="card">
                                    <div class="card-body p-2">
                                        <b-form-group class="col-md-8"
                                                      label-for="password">
                                            <template v-slot:label>
                                                <font-awesome-icon v-bind:icon="['fad', 'lock']"></font-awesome-icon> 登入密碼
                                            </template>
                                            <b-input-group>
                                                <b-form-input id="password"
                                                              v-bind:type="isPasswordInputFocused ? 'text' : 'password'"
                                                              required
                                                              v-model="password"
                                                              v-on:focus="isPasswordInputFocused = true"
                                                              v-on:blur="isPasswordInputFocused = false">
                                                </b-form-input>
                                                <b-input-group-append>
                                                    <button class="btn btn-light border rounded-right"
                                                            v-on:click.stop.prevent="generateRandomPassword">
                                                        產生密碼
                                                    </button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </div>
                                </div>
                            </b-collapse>
                        </div>
                    </div>

                    <div class="form-row"
                         v-show="allowLogin">
                        <b-form-group class="col-md-6"
                                      label-for="verification">
                            <template v-slot:label>
                                <font-awesome-icon v-bind:icon="['fad', 'user-shield']"></font-awesome-icon> 用戶驗證
                            </template>
                            <div id="verification"
                                 class="btn-group btn-group-sm">
                                <button type="button"
                                        class="btn border-right-0"
                                        v-bind:class="{ 'btn-success': verified, 'btn-outline-success': !verified, 'font-weight-bolder': verified }"
                                        v-on:click="verified = true">
                                    已驗證用戶
                                </button>
                                <button type="button"
                                        class="btn border-left-0"
                                        v-bind:class="{ 'btn-danger': !verified, 'btn-outline-danger': verified, 'font-weight-bolder': !verified }"
                                        v-on:click="verified = false">
                                    未驗證用戶
                                </button>
                            </div>
                        </b-form-group>

                        <b-form-group class="col-md-6"
                                      label-for="status">
                            <template v-slot:label>
                                <font-awesome-icon v-bind:icon="['fad', 'clipboard-check']"></font-awesome-icon> 審核狀態
                            </template>
                            <div id="status"
                                 class="btn-group btn-group-sm">
                                <button type="button"
                                        class="btn border-right-0"
                                        v-bind:class="{ 'btn-success': approved, 'btn-outline-success': !approved, 'font-weight-bolder': approved }"
                                        v-on:click="approved = true">
                                    已獲批準
                                </button>
                                <button type="button"
                                        class="btn border-left-0"
                                        v-bind:class="{ 'btn-danger': !approved, 'btn-outline-danger': approved, 'font-weight-bolder': !approved }"
                                        v-on:click="approved = false">
                                    待批準
                                </button>
                            </div>
                        </b-form-group>
                    </div>

                    <div class="form-row">
                        <b-form-group class="col-md-6"
                                      label-for="role">
                            <template v-slot:label>
                                <font-awesome-icon v-bind:icon="['fad', 'sitemap']"></font-awesome-icon> 用戶角色
                            </template>
                            <b-form-select id="role"
                                           class="bg-light"
                                           required
                                           v-model="role">
                                <b-form-select-option v-for="role in roles"
                                                      v-bind:key="role"
                                                      v-bind:value="role">
                                    {{ $config.roleMap[role] | capitalize }}
                                </b-form-select-option>
                            </b-form-select>
                        </b-form-group>

                        <b-form-group class="col-md-6"
                                      label-for="vendorId"
                                      v-if="['vending-vendor', 'vending-site-manager', ].includes(role)">
                            <template v-slot:label>
                                <font-awesome-icon v-bind:icon="['fad', 'id-badge']"></font-awesome-icon> 利興系統編號
                            </template>
                            <b-form-input id="vendorId"
                                          class="bg-light"
                                          type="text"
                                          required
                                          v-model="vendorId">
                            </b-form-input>
                        </b-form-group>

                        <b-form-group class="col-md-12"
                                      label-for="name">
                            <template v-slot:label>
                                <font-awesome-icon v-bind:icon="['fad', 'user']"></font-awesome-icon> 用戶名稱
                            </template>
                            <b-form-input id="name"
                                          class="bg-light"
                                          type="text"
                                          required
                                          v-model="name">
                            </b-form-input>
                        </b-form-group>
                    </div>

                    <div class="form-row">
                        <b-form-group class="col-md-6"
                                      label-for="country-code">
                            <template v-slot:label>
                                <font-awesome-icon v-bind:icon="['fad', 'globe-asia']"></font-awesome-icon> 國家區號
                            </template>
                            <b-form-select id="country-code"
                                           class="bg-light"
                                           required
                                           v-model="countryCode">
                                <b-form-select-option v-for="{ value, text } in countryCodes"
                                                      v-bind:key="value"
                                                      v-bind:value="value">
                                    {{ text }}
                                </b-form-select-option>
                            </b-form-select>
                        </b-form-group>
                    </div>

                    <div class="form-row">
                        <b-form-group class="col-md-6"
                                      label-for="phone">
                            <template v-slot:label>
                                <font-awesome-icon v-bind:icon="['fad', 'phone']"></font-awesome-icon> 電話號碼
                            </template>
                            <b-form-input id="phone"
                                          class="bg-light"
                                          type="tel"
                                          required
                                          v-model="phone">
                            </b-form-input>
                        </b-form-group>

                        <b-form-group class="col-md-6"
                                      label-for="fax">
                            <template v-slot:label>
                                <font-awesome-icon v-bind:icon="['fad', 'fax']"></font-awesome-icon> 傳真號碼 (可選填)
                            </template>
                            <b-form-input id="fax"
                                          class="bg-light"
                                          type="tel"
                                          v-model="fax">
                            </b-form-input>
                        </b-form-group>

                        <b-form-group class="col-md-12"
                                      label-for="email"
                                      invalid-feedback="已有帳戶使用此電郵地址"
                                      v-bind:state="isEmailUnique">
                            <template v-slot:label>
                                <font-awesome-icon v-bind:icon="['fad', 'at']"></font-awesome-icon> 電郵地址
                            </template>
                            <b-form-input id="email"
                                          class="bg-light"
                                          type="text"
                                          required
                                          v-bind:state="isEmailUnique"
                                          v-model="email">
                            </b-form-input>
                        </b-form-group>

                        <b-form-group class="col-md-12"
                                      label-for="address">
                            <template v-slot:label>
                                <font-awesome-icon v-bind:icon="['fad', 'map-marker-alt']"></font-awesome-icon> 地址 (可選填)
                            </template>
                            <b-form-textarea id="address"
                                             class="bg-light"
                                             v-model="address">
                            </b-form-textarea>
                        </b-form-group>

                        <b-form-group class="col-md-12"
                                      label-for="sites"
                                      v-if="role === 'vending-site-manager'">
                            <template v-slot:label>
                                <font-awesome-icon v-bind:icon="['fad', 'thumbtack']"></font-awesome-icon> 管理地盤
                            </template>
                            <v-select id="sites"
                                      class="bg-light"
                                      label="siteName"
                                      multiple
                                      v-bind:options="sites"
                                      v-model="managedSites">
                                <template v-slot:search="{ attributes, events }">
                                    <input class="vs__search"
                                           v-bind="attributes"
                                           v-on="events">
                                </template>
                                <template v-slot:option="{ siteName, address, }">
                                    <div class="-flex align-items-center">
                                        <div class="flex-grow-1">
                                            <h6 class="font-weight-bold mb-1">
                                                {{ siteName }}
                                            </h6>
                                            <p class="mb-0">
                                                <small>{{ address }}</small>
                                            </p>
                                        </div>
                                    </div>
                                </template>
                                <template v-slot:selected-option="{ siteName, address, }">
                                    <div class="-flex align-items-center">
                                        <div class="flex-grow-1">
                                            <h6 class="font-weight-bold mb-1">
                                                {{ siteName }}
                                            </h6>
                                            <p class="mb-0">
                                                <small>{{ address }}</small>
                                            </p>
                                        </div>
                                    </div>
                                </template>
                            </v-select>
                        </b-form-group>

                        <b-form-group class="col-md-12"
                                      label-for="notes">
                            <template v-slot:label>
                                <font-awesome-icon v-bind:icon="['fad', 'sticky-note']"></font-awesome-icon> 備注 (可選填)
                            </template>
                            <b-form-textarea id="notes"
                                             v-model="notes">
                            </b-form-textarea>
                        </b-form-group>
                    </div>
                </div>
            </div>

            <div class="text-center">
                <button class="btn px-4"
                        type="submit"
                        v-bind:class="{ 'btn-success': !isEditing, 'btn-warning': isEditing, 'btn-loading': isLoading }">
                    {{ isEditing? "✏️ 編輯" : "🆕 新增" }}
                </button>
            </div>
        </b-form>
    </b-modal>
</template>

<script>
import {
    BCollapse,
    BModal,
    BForm, BFormGroup,
    BInputGroup, BInputGroupAppend,
    BFormInput, BFormTextarea,
    BFormSelect, BFormSelectOption,
    BFormCheckbox,
} from "bootstrap-vue";
import vSelect from "vue-select";

export default {
    name: "ModalUser",
    components: {
        "v-select": vSelect,
        BCollapse,
        BModal,
        BForm, BFormGroup,
        BInputGroup, BInputGroupAppend,
        BFormInput, BFormTextarea,
        BFormSelect, BFormSelectOption,
        BFormCheckbox,
    },
    props: {
        "value": {
            type: Boolean,
        },
        "isEditing": {
            type: Boolean,
            default: false,
        },
        "user": {
            type: Object,
        },
    },
    data () {
        return {
            isLoading: false,
            isPasswordInputFocused: false,

            roles: [
                "vending-admin",
                "vending-vendor",
                "vending-site-manager",
            ],
            countryCodes: [
                {
                    text: "+852 香港",
                    value: "852",
                },
                {
                    text: "+86 中國",
                    value: "86",
                },
                {
                    text: "+853 澳門",
                    value: "853",
                },
            ],

            avatar: [],
            avatarFiles: [],

            allowLogin: false,
            verified: false,
            approved: false,
            role: null,

            vendorId: "",
            countryCode: "852",
            phone: "",
            fax: "",
            name: "",
            email: "",
            address: "",
            password: "",

            notes: "",
            managedSites: [],
        };
    },
    computed: {
        sites () {
            return this.$store.state.data.sites;
        },
        isEmailUnique () {
            if (this.email.length === 0) {
                return null;
            }
            if (this.user?.email === this.email) {
                return true;
            }
            return !this.$store.getters["users/isEmailUnique"](this.email);
        },
    },
    methods: {
        reset () {
            this.allowLogin = false;
            this.verified = false;
            this.approved = false;
            this.role = null;

            this.avatar = [];
            this.avatarFiles = [];

            this.vendorId = "";
            this.name = "";
            this.countryCode = "852";
            this.phone = "";
            this.fax = "";
            this.email = "";
            this.address = "";

            this.notes = "";
            this.managedSites = [];
        },
        hideModal () {
            this.$emit("input", false);
        },
        generateRandomPassword () {
            this.password = Math.random().toString(36).substr(2);
        },
        changeAvatar () {
            document
                .getElementById("avatar")
                .click();
        },
        async updateAvatar (e) {
            const temp = Array.from(e.target.files || e.dataTransfer.files);
            if (temp.length === 0) {
                return;
            }
            this.avatarFiles = temp;
            this.avatar = await Promise.all(
                this.avatarFiles.map(
                    file => {
                        const reader = new FileReader();
                        reader.readAsDataURL(file);
                        return new Promise(
                            (resolve) => {
                                reader.onload = (e) => {
                                    resolve(e.target.result);
                                };
                            }
                        );
                    }
                )
            );
        },

        submit () {
            if (this.isEditing) {
                this.editUser();
                return;
            }
            this.addUser();
        },

        async addUser () {
            this.isLoading = true;
            const {
                allowLogin, verified, approved, role, name, vendorId, password, countryCode, phone, fax, email, address, notes, managedSites,
            } = this;
            const payload = {
                allowLogin, verified, approved,
                role, name, vendorId, password,
                countryCode, phone, fax,
                email, address,
                "profile": {
                    notes,
                    "sites": managedSites,
                },
            };

            if (
                Array.isArray(this.avatarFiles) &&
                this.avatarFiles.length > 0
            ) {
                payload.avatar = this.avatarFiles[0];
            }

            try {
                await this.$store.dispatch(
                    "users/addUser",
                    payload
                );
            } catch (e) {
                console.error(e);
                this.isLoading = false;
                return;
            }
            this.isLoading = false;
            this.reset();
            this.hideModal();
        },

        async editUser () {
            this.isLoading = true;
            const {
                allowLogin, verified, approved, role, name, vendorId, password, countryCode, phone, fax, email, address, notes, managedSites,
            } = this;
            const payload = {
                "_id": this.user._id,
                allowLogin, verified, approved,
                role, name, vendorId, password,
                countryCode, phone, fax, email, address,
                "profile": {
                    notes,
                    "sites": managedSites,
                },
            };

            if (
                Array.isArray(this.avatarFiles) &&
                this.avatarFiles.length > 0
            ) {
                payload.avatar = this.avatarFiles[0];
            }

            try {
                await this.$store.dispatch(
                    "users/editUser",
                    payload
                );
            } catch (e) {
                console.error(e);
                this.isLoading = false;
                return;
            }
            this.isLoading = false;
            this.hideModal();
        },
    },
    mounted () {
        if (this.user) {
            this.allowLogin = this.user.allowLogin;
            this.verified = this.user.verified;
            this.approved = this.user.approved;
            this.role = this.user.role;

            this.avatar = this.user.avatar ?
                [`${ this.$config.apiUrl }/${ this.$config.apiVersion }/user/avatar/${ this.user.avatar }`] :
                [];
            this.avatarFiles = [];

            this.name = this.user.name;
            this.vendorId = this.user.vendorId;
            this.countryCode = this.user.countryCode;
            this.phone = this.user.phone;
            this.fax = this.user.fax;
            this.email = this.user.email;
            this.address = this.user.address;

            this.notes = this.user?.profile?.notes ?? "";
            this.managedSites = this.user?.profile?.sites ?? [];
        }
    },
    watch: {
        "user" (newVal) {
            if (newVal) {
                this.allowLogin = newVal.allowLogin;
                this.verified = newVal.verified;
                this.approved = newVal.approved;
                this.role = newVal.role;

                this.avatar = newVal.avatar ?
                    [`${ this.$config.apiUrl }/${ this.$config.apiVersion }/user/avatar/${ newVal.avatar }`] :
                    [];
                this.avatarFiles = [];

                this.name = newVal.name;
                this.vendorId = newVal.vendorId;
                this.countryCode = newVal.countryCode;
                this.phone = newVal.phone;
                this.fax = newVal.fax;
                this.email = newVal.email;
                this.address = newVal.address;

                this.notes = newVal?.profile?.notes ?? "";
                this.managedSites = newVal?.profile?.sites ?? [];
            }
        },
    },
}
</script>

<style lang="scss" scoped>
@import "../../../node_modules/bootstrap/scss/functions";
@import "../../../node_modules/bootstrap/scss/variables";
@import "../../../node_modules/bootstrap/scss/mixins/breakpoints";

.avatar-image {
    height: 200px;

    & > img {
        object-fit: contain;
    }

    &:hover,
    &:focus {
        &:after {
            content: "編輯用戶頭像";

            display: flex;
            justify-content: center;
            align-items: center;

            position: absolute;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;

            color: rgba(255, 255, 255, 1);
            background-color: rgba(0, 0, 0, 0.25);

            font-size: 2rem;
            font-weight: bolder;

            cursor: pointer;
        }
    }
}
</style>
